<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M16.6742 12.8437L8.53688 18.022C7.87115 18.4456 7 17.9674 7 17.1783V6.82169C7 6.0326 7.87115 5.55439 8.53688 5.97803L16.6742 11.1564C17.2917 11.5493 17.2917 12.4507 16.6742 12.8437Z"
		fill="currentColor"
	/>
</svg>
